module.exports = __webpack_public_path__ + "static/img/login_background_prod.b57bbd33.jpg";